import { reviewFormValidator } from "@redotech/redo-model/form-builder-form/db-validator/review/review-form-builder-form-validator";
import * as z from "zod/v4";

export const getActiveReviewForm = {
  name: "getActiveReviewForm" as const,
  input: z.null(),
  output: reviewFormValidator.nullable(),
};
